"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsPickerDesktop = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SearcherFlexBadge = _interopRequireDefault(require("../SearcherFlexBadge"));

var _SearchSelect = require("../SearchSelect");

var _NightsCounter = require("./NightsCounter");

var _userflow = require("../../utils/userflow");

var _constants = require("./constants");

// Components:
// Utils:
var NightsPickerDesktop = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var nights = _ref.nights,
      _ref$flexNights = _ref.flexNights,
      flexNights = _ref$flexNights === void 0 ? false : _ref$flexNights,
      _ref$minValue = _ref.minValue,
      minValue = _ref$minValue === void 0 ? 1 : _ref$minValue,
      _ref$maxValue = _ref.maxValue,
      maxValue = _ref$maxValue === void 0 ? 30 : _ref$maxValue,
      _ref$onChangeNights = _ref.onChangeNights,
      onChangeNights = _ref$onChangeNights === void 0 ? function () {
    return undefined;
  } : _ref$onChangeNights,
      _ref$onChangeFlexNigh = _ref.onChangeFlexNights,
      onChangeFlexNights = _ref$onChangeFlexNigh === void 0 ? function () {
    return undefined;
  } : _ref$onChangeFlexNigh,
      _ref$showFlexNights = _ref.showFlexNights,
      showFlexNights = _ref$showFlexNights === void 0 ? true : _ref$showFlexNights,
      CustomControl = _ref.CustomControl,
      CustomLabel = _ref.CustomLabel;

  var handleChange = function handleChange(val) {
    onChangeNights(val);
  };

  var CustomOption = function CustomOption() {
    return /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
      value: nights,
      onValueChange: handleChange,
      minValue: minValue,
      maxValue: maxValue,
      showFlexNights: showFlexNights,
      checked: flexNights,
      onCheckedChange: onChangeFlexNights
    });
  };

  var Option = {
    custom: true,
    CustomComponent: CustomOption
  };
  var SingleValue = CustomControl ? CustomLabel : function (props) {
    var innerProps = props.innerProps,
        selectProps = props.selectProps;
    var menuIsOpen = selectProps.menuIsOpen;
    return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({}, innerProps, {
      menuIsOpen: menuIsOpen
    }), "".concat(nights, " ").concat((0, _userflow.pluralize)(nights, _constants.NIGHTS_VALUES)), flexNights ? /*#__PURE__*/_react["default"].createElement(StyledSearcherFlexBadge, null) : null);
  };
  var CustomDropdownIndicator = CustomControl ? function () {
    return null;
  } : undefined;
  var customStyles = {
    menu: function menu() {
      return {
        width: 230,
        maxHeight: 97
      };
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    CustomSingleValue: SingleValue,
    CustomControl: CustomControl,
    CustomDropdownIndicator: CustomDropdownIndicator,
    options: [Option],
    customStyles: customStyles,
    isSearchable: false,
    isClearable: false,
    closeMenuOnSelect: false,
    captureMenuScroll: false,
    menuShouldBlockScroll: false
  });
});

exports.NightsPickerDesktop = NightsPickerDesktop;
NightsPickerDesktop.displayName = 'NightsPicker';

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "NightsPickerdesktop__StyledLabel",
  componentId: "sc-1xflbcy-0"
})(["display:flex;align-items:center;font-size:16px;line-height:20px;font-weight:", ";color:", ";"], function (_ref2) {
  var menuIsOpen = _ref2.menuIsOpen;
  return menuIsOpen ? 'normal' : 'bold';
}, function (_ref3) {
  var menuIsOpen = _ref3.menuIsOpen,
      theme = _ref3.theme;
  return menuIsOpen ? theme.colors.lightGrey : theme.colors.blackBase;
});

var StyledSearcherFlexBadge = (0, _styledComponents["default"])(_SearcherFlexBadge["default"]).withConfig({
  displayName: "NightsPickerdesktop__StyledSearcherFlexBadge",
  componentId: "sc-1xflbcy-1"
})(["margin-left:5px;margin-top:2px;display:flex;align-items:center;justify-content:center;"]);